export const events = {
    closeSideNav: 'sermonshots-close-sidenav',
    closeVideoInformationDialog: 'sermonshots-close-video-information-dialog',
    openSideNav: 'sermonshots-open-sidenav'
};
